









































































import { Vue, Component, Ref, Watch } from "vue-property-decorator";
import DefinitionValue from "@/models/definitionValue";
import DefinitionsAPI from "@/services/definitions";
import TableActions from "@/components/TableActions.vue";
import DefinitionValueForm from "./DefinitionValueForm.vue";
import { Form, Meta } from "@/models/general";
import { LayoutModule } from "@/store/layout";
import { cloneDeep, get } from "lodash";
import Modal from "@/components/Modal.vue";

@Component({
  components: { TableActions, DefinitionValueForm, Modal },
})
export default class DefinitionValues extends Vue {
  @Ref("newValueForm") newValueForm!: Form;
  @Ref("editValueForm") editValueForm!: Form;

  values: DefinitionValue[] = [];
  model: DefinitionValue = new DefinitionValue();
  editModel: DefinitionValue = new DefinitionValue();
  loader = {
    values: true,
    create: false,
    edit: false,
  };
  editDialog = false;
  meta: Meta = new Meta();
  pagination = {};

  headers = [
    {
      text: this.$t("definitions.values.model.name"),
      value: "name",
    },
    {
      text: this.$t("definitions.values.model.value"),
      value: "value",
    },
    { text: "", value: "actions", sortable: false },
  ];

  get definitionId(): string {
    return this.$route.params.id;
  }

  get isEditing(): boolean {
    return Boolean(this.definitionId);
  }

  created(): void {
    if (this.isEditing) this.getValues();
  }

  async getValues(): Promise<void> {
    this.loader.values = true;
    const r = await DefinitionsAPI.values.list(this.definitionId);

    this.meta = new Meta(r.meta);
    this.values = r.data.map((i) => new DefinitionValue(i));
    this.loader.values = false;
  }

  async createValue(): Promise<void> {
    try {
      if (this.newValueForm.validate()) {
        this.loader.create = true;
        await DefinitionsAPI.values.new(this.definitionId, this.model);
        this.newValueForm.reset();
        this.loader.create = false;
        this.getValues();
      }
    } catch (error) {
      console.log(error);
      this.loader.create = false;
    }
  }

  deleteItem(item: DefinitionValue): void {
    LayoutModule.setDialogTitle("definitions.values.delete");
    LayoutModule.setDialogType("error");
    LayoutModule.setDialogCallback(
      async (): Promise<null> => {
        LayoutModule.showLoader();
        await DefinitionsAPI.values.delete(this.definitionId, item);
        await this.getValues();
        LayoutModule.hideLoader();
        return null;
      }
    );
    LayoutModule.showDialog();
  }

  editItem(item: DefinitionValue): void {
    this.editModel = cloneDeep(item);
    this.$nextTick(() => {
      this.editDialog = true;
    });
  }

  closeEditDialog(): void {
    this.editDialog = false;
    this.$nextTick(() => {
      this.editModel = new DefinitionValue();
    });
  }

  async updateLabel(): Promise<void> {
    try {
      const isValid = this.editValueForm.validate();
      if (isValid) {
        this.loader.edit = true;
        await DefinitionsAPI.values.update(this.definitionId, this.editModel);
        this.loader.edit = false;
        this.closeEditDialog();
        await this.getValues();
      }
    } catch (error) {
      console.log(error);
      this.loader.edit = false;
    }
  }

  @Watch("pagination", { deep: true })
  handlePagination(): void {
    this.meta.pagination.current = get(this.pagination, "page");
    this.meta.pagination.size = get(this.pagination, "itemsPerPage");

    this.getValues();
  }
}
